import {AppAction} from '../appActions';
import {FeatureFlagsActionsEnum} from './featureFlagsActions';
import {FeatureFlagsState} from './featureFlagsState';

/*
 * Reducer.
 */

export function featureFlagsReducer(
  state: FeatureFlagsState | undefined,
  action: AppAction,
): FeatureFlagsState {
  const initial = state?.initial || {};
  const dynamic = state?.dynamic || {};

  switch (action.type) {
    case FeatureFlagsActionsEnum.UPDATE:
      return {
        initial,
        dynamic: {
          ...dynamic,
          ...action.payload,
        },
      };

    default: {
      if (state) {
        return state;
      }

      return {
        initial,
        dynamic,
      };
    }
  }
}
